import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { MatSidenavModule } from "@angular/material/sidenav";
import { RouterOutlet } from "@angular/router";

import { AngularSplitModule, SplitGutterInteractionEvent } from "angular-split";
import { SidenavStateService } from "src/modules/shared/services/sidenav-state.service";

import { FooterComponent } from "../footer/footer.component";
import { TopNavComponent } from "../top-nav/top-nav.component";

@Component({
  selector: "app-home-layout",
  templateUrl: "./home-layout.component.html",
  styleUrls: ["./home-layout.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatSidenavModule, TopNavComponent, FooterComponent, AngularSplitModule, RouterOutlet],
})
export class HomeLayoutComponent {
  private readonly sidenavService = inject(SidenavStateService);

  readonly open = this.sidenavService.opened;

  readonly sidenavSize: number;
  readonly minSize = 360;

  constructor() {
    const stored = parseFloat(window.localStorage.getItem("retrodigital.homelayout.sidenav-size") ?? "");
    // A size persisted on a wide viewport must not swallow the whole split on a
    // narrow one: keep it within [minSize, viewport - minSize] so the content
    // area always retains at least minSize.
    const maxSize = Math.max(this.minSize, window.innerWidth - this.minSize);
    this.sidenavSize = isNaN(stored) ? this.minSize : Math.min(Math.max(stored, this.minSize), maxSize);
  }

  readonly isOver = computed(() => this.open() && this.sidenavService.mode() === "over");

  onOverlayClick(e: MouseEvent) {
    e.stopImmediatePropagation();
    e.preventDefault();
    this.sidenavService.close();
  }

  onSplitterDragEnd(e: SplitGutterInteractionEvent) {
    const sidenavSize = parseFloat(e.sizes[0]?.toString() ?? "");
    if (isNaN(sidenavSize)) return;
    window.localStorage.setItem("retrodigital.homelayout.sidenav-size", sidenavSize.toString());
  }
}
